<ng-container *ngIf="vm | contentCoreData | async as contentCoreData; else shimmerLoad">
  <div class="image-container" dir="ltr">
    <p class="ranking rank" *ngIf="ranking">
      <svg-icon [key]="rankingIcon" width="100%" height="100%"></svg-icon>
    </p>
    <!-- click listener is required for video start and google tag manager measures -->
    <a
      tabindex="0"
      [state]="navigationState"
      [routerLink]="playMediaOnClick ? null : contentCoreData.routerLink"
      [replaceUrl]="replaceUrl"
      [class.top-10-padding]="ranking"
    >
      <div
        [className]="ranking ? 'card' + ' ' + 'top-ten-item-pink-border' : 'card'"
        osnSharedPreviewOverlay
        [preventHover]="preventHover"
        [overlayVm]="vm | shallowPreviewOverlayVmPipe: previewImgQuery | async"
        [playMediaOnClick]="playMediaOnClick"
        (hovered)="onCarouselItemHovered($event)"
        (itemSelect)="onCarouselItemSelected()"
        [class.no-shadow]="hideShadow"
        [@openClose]="hovered ? 'open' : 'closed'"
      >
        <div osnSharedAspectRatio="{{ aspectRatio }}">
          <img osnSharedUseAsPicture class="bg-image" [src]="getImageUrl(contentCoreData)" [imgQuery]="imgQuery" [alt]="vm.title.en" />
        </div>
        <div *ngIf="showBlur" class="carousel-item-blur"></div>
        <div class="carousel-item-detail-container" [class.wide]="isArabic$ | async">
          <div class="title-icon-container">
            <div class="play-icon-container" *ngIf="playMediaOnClick" data-testid="BasePage.continueWatchingCarouselItemPlayIcon">
              <svg-icon key="continue-watching-play-icon"></svg-icon>
            </div>
            <ng-container *ngIf="vm.type === 'episode' && showEpisodeNumbers">
              <div
                *ngIf="vm | contentExtendedData | async as extendedContentData"
                class="season-episode-number"
                data-testid="BasePage.continueWatchingCarouselItemEpisodeNumber"
              >
                {{
                  'SD_Episode_Info_txt'
                    | translate: { season: extendedContentData.bookmark.seasonNumber, episode: extendedContentData.bookmark.episodeNumber }
                }}
              </div>
            </ng-container>
          </div>
          <ng-container *ngIf="showProgressBar">
            <osn-shared-progress-bar
              *ngIf="vm | contentExtendedData | async as extendedContentData"
              data-testid="BasePage.continueWatchingCarouselItemProgressBar"
              [theme]="whiteProgressBar ? 'white' : 'pink'"
              [lengthInSeconds]="extendedContentData.bookmark.contentLength"
              [elapsedInSeconds]="extendedContentData.bookmark.bookmarkTime"
            ></osn-shared-progress-bar>
          </ng-container>
        </div>
      </div>
    </a>
  </div>
  <a
    *ngIf="showSeoTitle"
    tabindex="0"
    [state]="navigationState"
    [routerLink]="contentCoreData.routerLink"
    [replaceUrl]="replaceUrl"
    class="seo-carousel-item-title"
    [class.top-10-padding]="ranking"
    >{{ seoTitle }}</a
  >

  <!-- Needed to preload preview landscape image for portrait carousel item -->
  <div class="d-none" *ngIf="hovered && !isLandscape">
    <img
      osnSharedUseAsPicture
      class="bg-image"
      [src]="contentCoreData.landscapeImageUrl"
      [imgQuery]="previewImgQuery"
      [alt]="vm.title.en"
    />
  </div>
</ng-container>
<ng-template #shimmerLoad>
  <div class="image-container" dir="ltr">
    <p class="ranking rank" *ngIf="ranking">
      <svg-icon [key]="rankingIcon" width="100%" height="100%"></svg-icon>
    </p>
    <!-- click listener is required for video start and google tag manager measures -->
    <a tabindex="0" [state]="navigationState" [routerLink]="null" [replaceUrl]="replaceUrl" [class.top-10-padding]="ranking">
      <div [className]="ranking ? 'card' + ' ' + 'top-ten-item-pink-border' : 'card'" [class.no-shadow]="hideShadow">
        <osn-shared-shimmer-loading [useDynamicFullSize]="true" osnSharedAspectRatio="{{ aspectRatio }}"></osn-shared-shimmer-loading>
      </div>
    </a>
  </div>
</ng-template>
